<script lang="ts">
	import { t } from 'svelte-i18n';
	import MainNavItemWithDropdown from './MainNavItemWithDropdown.svelte';
	import getInvestorsNavItems from '../getInvestorsNavItems';
	import { page } from '$app/stores';
</script>

<MainNavItemWithDropdown
	label={$t('nav.header.investors.label')}
	subItems={getInvestorsNavItems($t, $page)}
	isOpen={!$page.data?.user}
/>
